module.exports = __webpack_public_path__ + "static/linkedin-55749c06f1223fb18b9c095ee7c67407.svg";